import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { AddCircleOutline } from '@mui/icons-material';
import { useCallback } from 'react';
import { useNavigateTo } from 'shared/hooks/router';
export function AddDeviceButton(props) {
    const { closeMenu, ...rest } = props;
    const navigate = useNavigateTo(`/new-device`);
    const addDevice = useCallback(() => {
        navigate();
        closeMenu();
    }, [closeMenu]);
    return (_jsx(Button, { variant: "outlined", startIcon: _jsx(AddCircleOutline, {}), onClick: addDevice, fullWidth: true, "data-tooltip": "add-device-button", ...rest, children: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E" }));
}
